(() => {
  const btn = document.querySelector('.menu-btn');
  const nav = document.getElementById('nav');
  if (btn && nav) {
    btn.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', open);
    });
  }
})();

/* Shopify Forms: 🐾-emoji vervangen door het pootje in huiskleur */
(() => {
  const PAW = '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="#A08860" aria-hidden="true" style="display:inline-block;vertical-align:-0.1em;margin-left:.15em"><ellipse cx="12" cy="16.5" rx="5.6" ry="4.6"/><ellipse cx="4.8" cy="10.2" rx="2.3" ry="2.9"/><ellipse cx="9.3" cy="5.4" rx="2.3" ry="3"/><ellipse cx="14.7" cy="5.4" rx="2.3" ry="3"/><ellipse cx="19.2" cy="10.2" rx="2.3" ry="2.9"/></svg>';
  const EMOJI = /\u{1F43E}️?/u;

  const paint = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const hits = [];
    while (walker.nextNode()) {
      const n = walker.currentNode;
      if (EMOJI.test(n.nodeValue) && n.parentNode && n.parentNode.nodeName !== 'STYLE') hits.push(n);
    }
    hits.forEach(n => {
      const span = document.createElement('span');
      span.innerHTML = n.nodeValue.split(EMOJI).map(t => t.replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]))).join(PAW);
      n.replaceWith(...span.childNodes);
    });
  };

  const watch = host => {
    if (!host.shadowRoot || host.dataset.pawsWatched) return;
    host.dataset.pawsWatched = '1';
    paint(host.shadowRoot);
    new MutationObserver(() => paint(host.shadowRoot)).observe(host.shadowRoot, { childList: true, subtree: true, characterData: true });
  };

  const scan = () => document.querySelectorAll('shopify-forms-embed').forEach(watch);
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  let tries = 0;
  const timer = setInterval(() => { scan(); if (++tries > 20) clearInterval(timer); }, 500);
})();

/* inschrijfformulier: nestje vooraf aanvinken via ?nestje=... of door op een nestje te klikken */
(() => {
  const findRadio = value => {
    for (const host of document.querySelectorAll('shopify-forms-embed')) {
      const radio = host.shadowRoot && [...host.shadowRoot.querySelectorAll('input[type="radio"]')].find(r => r.value === value);
      if (radio) return radio;
    }
    return null;
  };
  const pick = (value, scroll) => {
    let tries = 0;
    const attempt = () => {
      const radio = findRadio(value);
      if (radio) {
        if (!radio.checked) radio.click();
        if (scroll) radio.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (++tries < 40) {
        setTimeout(attempt, 250);
      }
    };
    attempt();
  };

  const wanted = new URLSearchParams(location.search).get('nestje');
  if (wanted) pick(wanted, false);

  document.querySelectorAll('[data-nestje]').forEach(card => {
    card.addEventListener('click', () => pick(card.dataset.nestje, true));
    card.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(card.dataset.nestje, true); } });
  });
})();

/* gekozen nestje-knop markeren */
document.addEventListener('click', e => {
  const btn = e.target.closest('.side-litter__btn');
  if (!btn) return;
  document.querySelectorAll('.side-litter__btn').forEach(b => { b.classList.toggle('is-chosen', b === btn); b.textContent = b === btn ? (b.dataset.chosen || 'Gekozen ✓') : b.dataset.label || b.textContent; });
});
document.querySelectorAll('.side-litter__btn').forEach(b => { b.dataset.label = b.textContent; });

/* gekozen nestje-tegel markeren (kleine schermen) */
document.addEventListener('click', e => {
  const card = e.target.closest('.side-litter[data-nestje]');
  if (!card) return;
  document.querySelectorAll('.side-litter').forEach(c => c.classList.toggle('is-picked', c === card));
});

/* Beweging: blokken schuiven rustig in beeld, pootjes lopen rond de foto */
(() => {
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const SELECTORS = [
    '.welcome > *', '.section-head', '.steps-head', '.dog-card', '.dog-row', '.fact', '.facts-band h2',
    '.about-story .rte > p', '.about-quote', '.about-value', '.step', '.image-row', '.photo-band',
    '.cta-strip', '.breed-text__card', '.breed-text__body', '.side-litter', '.care > *', '.page-intro'
  ].join(',');
  document.documentElement.classList.add('js-reveal');

  const items = [...document.querySelectorAll(SELECTORS)];
  items.forEach(el => {
    el.classList.add('reveal');
    const siblings = [...el.parentElement.children].filter(c => c.matches(SELECTORS));
    const i = siblings.indexOf(el);
    if (i > 0) el.style.setProperty('--reveal-delay', Math.min(i, 4) * 0.12 + 's');
  });
  const frames = [...document.querySelectorAll('.paw-frame')];
  frames.forEach(f => f.querySelectorAll('use').forEach((u, i) => u.style.setProperty('--i', i)));

  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.classList.add(e.target.matches('.paw-frame') ? 'is-walking' : 'is-visible');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  items.concat(frames).forEach(el => io.observe(el));

  const scripts = [...document.querySelectorAll('.about-kicker, .steps-kicker, .about-hero h1, .breed-hero h1, .breed-word__word, .image-rows-section .steps-head h2')];
  const wio = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.querySelectorAll(':scope > .write').forEach(w => w.classList.add('is-written'));
      wio.unobserve(e.target);
    });
  }, { threshold: 0.2 });
  /* de titel zelf is weggeknipt, dus we kijken naar het blok eromheen */
  scripts.forEach(el => { el.classList.add('write'); wio.observe(el.parentElement); });
})();

/* Fotoboek: de Instagram-naam boven de feed is een link naar Instagram */
(() => {
  const link = h => {
    if (h.querySelector('a')) return;
    const handle = h.textContent.trim().replace(/^@/, '');
    if (!/^[\w.]+$/.test(handle)) return;
    const a = document.createElement('a');
    a.href = 'https://www.instagram.com/' + handle + '/';
    a.target = '_blank';
    a.rel = 'noopener';
    a.className = 'insta-handle';
    a.textContent = h.textContent.trim();
    h.replaceChildren(a);
  };
  const find = () => { const h = document.querySelector('#insta-feed > h2'); if (h) { link(h); return true; } return false; };
  if (find()) return;
  const mo = new MutationObserver(() => { if (find()) mo.disconnect(); });
  mo.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => mo.disconnect(), 15000);
})();
